<template>
  <div style="padding-top: 10px;">
    <eco-runtime-template
      :templateKey="templateKey"
      :html="html"
      :templateInfo="templateInfo"
      :single="single"
      :taskType="taskType"
      :isJoinFlow="isJoinFlow"
      :dataView="dataView"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Message } from "element-ui";
import { Loading } from "element-ui";
import EcoDialog from "@/components/control/FeDialog.vue";
import EcoDialogBtn from "@/components/control/FeDialogBtn.vue";
import VRuntimeTemplate from "v-runtime-template";
import utils from "@/utils.js";
import ecoUiUtils from "@/eco-ui-util.js";
import { Base64 } from "js-base64";
import Vue from "vue";
import QRCode from "qrcode";
import req from "@/request.js";
import form from "@/api/form.js";
import dialog from "@/api/dialogApi.js";

export default {
  name: "template-dynamic-view",
  props: {
    templateKey: String,
    html: String,
    templateInfo: Object,
    parameterqQuerys: String,
    single: String,
    defKey: String,
    taskType: {
      default: ""
    },
    dataView: Object,
    isJoinFlow: {
      default: false
    }
  },
  created() {
    this.init();
  },
  watch: {
    html: function(newVal) {
      if (newVal) {
        this.init();
      }
    }
  },
  methods: {
    init() {
      Vue.component("eco-runtime-template", {
        template: this.html,
        props: {
          templateKey: String,
          templateInfo: Object,
          single: String,
          defKey: String,
          taskType: {
            default: ""
          },
          dataView: Object,
          isJoinFlow: {
            default: false
          }
        },
        data() {
          return {
            loading: false,
            QRCodeurl: "",
            QRCodeDialog: false,
            html: "",
            tableData: { selectRows: [], querys: "" },
            dialogExportVisible: false,
            exportData: { getType: "all", expField: [] },
            displayFields: [],
            exportSellection: [],
            searchForm: { F_xb: "", F_xm: "" },
            queryForm: {
              queryData: ""
            },
            formType: false,
            labelPosition: "left",
            incons: "el-icon-arrow-down",
            options: {
              fullscreen: true,
              lock: true
            },
            rowTemplateId: null,
            rowId: null,
            QRCodeShow: true,
            QRCodeDesc: [],
            tree: [],
            customDialog: [],
            tableHeight: 0.685 * window.innerHeight,
            dialogSubVisible: false,
            tabs: [],
            ents: [],
            modifyRecord: {
              pagination: {
                pageBean: {
                  page: 1,
                  pageSize: 10,
                  total: 0
                }
              }
            },
            recordList: [],
            recordRefId: "",
            dialogRecordVisible: false,
            recordTableLoading: false,
            modifyDetailDialogVisible: false,
            currentModify: {},
            refId: "",
            querySubValue: "",
            subTableLoading: false,
            currentTabName: "",
            currentTab: {},
            exportType: "main",
            subDisplayFields: [],
            subDisplayFieldsList: [],
            notPrint: false,
            displayField: {},
            treeList: [],

            // customColumn
            customColumns: [],
            currentCustomColumns: null,
            judgeCustomColumns: null,
            customColumnsHashCode: null,
            customColumnDialogVisible: false
          };
        },
        computed: {
          ...mapState({
            rows: state => state.form.bpmTemplateRows,
            pagination: state => state.form.bpmTemplatePagination,
            total: state => state.form.bpmTemplateTotal
          })
        },
        components: {
          VRuntimeTemplate,
          EcoDialog,
          EcoDialogBtn
        },
        watch: {
          templateKey: function(newVal) {
            if (newVal) {
              this.init();
            }
          },
          ents: {
            handler: function(newVal, oldValue) {
              if (newVal && newVal.length >= 1 && newVal != oldValue) {
                this.getSubData(this, this.refId);
              }
            },
            deep: true,
            immediate: true
          },
          templateInfo: {
            handler: function(newVal, oldVal) {
              if (newVal) {
                if (newVal.treeField && newVal.treeField !== "{}") {
                  let treeField = JSON.parse(newVal.treeField);
                  this.initTree(treeField);
                  form.getSubEntsByFormKey(this.templateInfo.formKey, resp => {
                    resp.data.forEach(item => {
                      let subDisplayFields = [];
                      item.attributeList.forEach(attr => {
                        subDisplayFields.push({
                          desc: attr.comment,
                          name: attr.fieldName,
                          type: attr.columnType
                        });
                      });
                      this.subDisplayFields.push({
                        fields: subDisplayFields,
                        name: item.name,
                        comment: item.comment
                      });
                    });
                  });
                }
              }
            },
            deep: true,
            immediate: true
          },
          currentTabName: function(newVal) {
            if (newVal) {
              this.querySubValue = "";
            }
          }
        },
        mounted() {
          //数据视图控件
          let _me = this;
          if (this.dataView) {
            const pInst = utils.getOnlineFormInstance(this.$parent);
            //关联查询字段
            if (this.dataView.bindSelectd && this.dataView.bindSelectd != "") {
              const path =
                "data." +
                this.dataView.boDefAlias +
                "." +
                this.dataView.selectField;
              const value = utils.getValueByPath(pInst, path);
              this.dataView.selectValue = value;
              pInst.$watch(path, function(newVal, oldVal) {
                if (newVal !== oldVal) {
                  _me.dataView.selectValue = newVal;
                  _me.search();
                }
              });
            }
            //关联填充字段
            if (this.dataView.fillField && this.dataView.fillField != "") {
              const path =
                "data." +
                this.dataView.boDefAlias +
                "." +
                this.dataView.fillField;
              const value = utils.getValueByPath(pInst, path);
              this.dataView.fillValue = value;
              pInst.$watch(path, function(newVal, oldVal) {
                if (newVal !== oldVal) {
                  _me.dataView.fillValue = newVal;
                }
              });
            }
          }

          //初始化 customColumns
          this.$nextTick(() => {
            (this.$refs["multipleTemplateTable"].$slots.default || []).forEach(
              slot => {
                if (
                  slot &&
                  slot.componentOptions &&
                  slot.componentOptions.propsData &&
                  slot.componentOptions.propsData.prop &&
                  slot.componentOptions.propsData.label
                ) {
                  this.customColumns.push({
                    key: slot.componentOptions.propsData.prop,
                    value: slot.componentOptions.propsData.label
                  });
                }
              }
            );
            this.customColumnsHashCode = ecoUiUtils.hashCode(
              JSON.stringify(this.customColumns)
            );
            let keys = this.getLocalStorage();
            this.customColumns.forEach(col => {
              if (keys === null || keys.indexOf(col.key) > -1) {
                this.currentCustomColumns
                  ? (this.currentCustomColumns += "," + col.key)
                  : (this.currentCustomColumns = col.key);
              }
            });
            this.judgeCustomColumns = this.currentCustomColumns;
            this.$refs["multipleTemplateTable"].doLayout();
          });
        },
        methods: {
          printList() {
            this.notPrint = true;
            setTimeout(() => {
              document.body.innerHTML = document.getElementById(
                "printData"
              ).innerHTML;
              window.print();
              location.reload();
            }, 200);
            setTimeout(() => {
              this.notPrint = false;
            }, 200);
          },
          printDetail(templateId, id, action) {
            var url =
              "/statement/template/form/" + this.templateKey + "/" + action;
            if (id) {
              url = url + "?id=" + id + "&";
            } else {
              url += "?";
            }
            var startFlowStr = "startFlow=false";
            this.$router.push({
              path: url + startFlowStr,
              query: { isPrint: true }
            });
          },
          complete(instId) {
            const me_ = this;
            var url =
              window.context.bpmRunTime +
              "/runtime/task/v1/getBpmTaskByInstId?instId=" +
              instId;
            req.get(url).then(function(res) {
              if (res.data.length == 0) {
                this.$message.error("此任务已被处理或不存在！");
              } else if (res.data.length == 1) {
                me_.$router.push("/task/" + res.data[0].id + "/0");
              } else {
                let html =
                  "<select ref=" +
                  Math.random() +
                  ' id="approvalLeaderSelect" style="width: 200px;height: 30px;border-radius: 4px;margin: 20px 70px;" ><option value="">请选择</option>';
                res.data.forEach(identity => {
                  html +=
                    '<option value="' +
                    identity.id +
                    '">' +
                    identity.name +
                    "</option>";
                });
                html += "</select>";
                me_.$alert(html, "请选择一个代办任务审批", {
                  dangerouslyUseHTMLString: true,
                  beforeClose: function(action, instance, done) {
                    if (action == "confirm") {
                      let se = document.getElementById("approvalLeaderSelect");
                      if (se.selectedIndex == 0) {
                        me_.$message.warning("请选择要审批的任务");
                      } else {
                        instance.close();
                        me_.$router.push(
                          "/task/" + se[se.selectedIndex].value + "/0"
                        );
                      }
                    } else {
                      instance.close();
                    }
                  }
                });
              }
            });
          },
          //下载全部选中的二维码
          downloadAllQRCode(templateId, mobileFormAlias, display, pkField) {
            const _selectData = this.$refs.multipleTemplateTable.selection;
            if (_selectData.length === 0) {
              this.$message.error("请至少选中一条数据!");
              return;
            }
            this.loading = true;
            let account = Base64.encode(
              this.$store.state.login.currentUser.account
            );
            let token = this.$store.state.login.currentUser.token;
            let front = req.getContext().front;
            let QRCodeurl = "";
            let zip = new JSZip();
            // 创建一个名为images的新的文件目录
            let img = zip.folder("images");
            let plist = [];
            for (let x = 0; x < _selectData.length; x++) {
              QRCodeurl =
                front +
                "/QRCodeForm/" +
                this.templateKey +
                "/get" +
                "?id=" +
                _selectData[x][pkField] +
                "&token=" +
                token;
              let msg = document.createElement("canvas");

              QRCode.toCanvas(msg, QRCodeurl, function(error) {
                console.log(error);
              });
              let _canvas = document.createElement("div");
              _canvas.setAttribute("id", "QRCodeAndDescAll" + x);
              _canvas.setAttribute(
                "style",
                "text-align:center;width:" + msg.width + "px;"
              );
              _canvas.appendChild(msg);
              //创建底部的描述信息
              for (let Y = 0; Y < display.length; Y++) {
                let item = JSON.parse(display[Y]);
                if (_selectData[x][item.name]) {
                  let desc = document.createElement("div");
                  desc.innerHTML = item.desc + ":" + _selectData[x][item.name];
                  _canvas.appendChild(desc);
                }
              }
              document.getElementById("QRCodeAndDescAll").appendChild(_canvas);
              plist.push(
                this.downloadQRCodeAndDesc("#QRCodeAndDescAll" + x, _canvas)
              );
            }
            Promise.all(plist).then(result => {
              document.getElementById("QRCodeAndDescAll").innerHTML = "";
              for (let x = 0; x < result.length; x++) {
                let canvas = result[x];
                let image = canvas.toDataURL().split(";base64,")[1];
                // 这个images文件目录中创建一个base64数据为imgData的图像，图像名是smile.gif
                img.file(x + ".png", image, { base64: true });
              }
              // 把打包内容异步转成blob二进制格式
              zip.generateAsync({ type: "blob" }).then(function(content) {
                let eleLink = document.createElement("a");
                eleLink.download = "二维码.zip";
                eleLink.style.display = "none";
                // 下载内容转变成blob地址
                eleLink.href = URL.createObjectURL(content);
                // 触发点击
                document.body.appendChild(eleLink);
                eleLink.click();
                // 然后移除
                document.body.removeChild(eleLink);
              });

              this.loading = false;
            });
          },
          onCopy(e) {
            this.$message.success("内容已复制到剪切板！");
          },
          // 复制失败时的回调函数
          onError(e) {
            this.$message.error("抱歉，复制失败！");
          },
          downloadQRCode() {
            let plist = [];
            let _canvas = document.querySelector("#QRCodeAndDesc");
            plist.push(this.downloadQRCodeAndDesc("#QRCodeAndDesc", _canvas));
            Promise.all(plist).then(result => {
              let canvas = result[0];
              let link = document.createElement("a");
              link.href = canvas.toDataURL(); //下载链接
              link.setAttribute("download", "二维码.jpg");
              link.style.display = "none"; //a标签隐藏
              document.body.appendChild(link);
              link.click();
            });
          },
          //把二维码与二维码说明一起下载成图片
          downloadQRCodeAndDesc(classs, _canvas) {
            let p2 = new Promise((resolve, reject) => {
              let canvas2 = document.createElement("canvas");
              let w = parseInt(window.getComputedStyle(_canvas).width);
              let h = parseInt(window.getComputedStyle(_canvas).height);
              //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
              canvas2.width = w * 2;
              canvas2.height = h * 2;
              canvas2.style.width = w + "px";
              canvas2.style.height = h + "px";
              //可以按照自己的需求，对context的参数修改,translate指的是偏移量
              let context = canvas2.getContext("2d");
              context.scale(2, 2);
              return html2canvas(document.querySelector(classs), {
                canvas: canvas2
              }).then(function(canvas) {
                resolve(canvas);
              });
            });
            return p2;
          },
          QRCodeDialogClose() {
            this.QRCodeDialog = false;
          },
          foundQRCode() {
            this.QRCodeurl =
              req.getContext().front +
              "/QRCodeForm/" +
              this.templateKey +
              "/get" +
              "?id=" +
              this.rowId +
              "&token=" +
              this.$store.state.login.currentUser.token;
            // Base64.encode(this.$store.state.login.currentUser.account);
            let msg = document.getElementById("QRCode");

            QRCode.toCanvas(msg, this.QRCodeurl, function(error) {
              console.log(error);
            });
            this.QRCodeShow = true;
          },
          getQRCode(templateId, id, mobileFormAlias, display, index) {
            this.QRCodeDesc = [];
            for (let x = 0; x < display.length; x++) {
              let item = JSON.parse(display[x]);
              if (this.rows[index][item.name]) {
                this.QRCodeDesc.push(
                  item.desc + ":" + this.rows[index][item.name]
                );
              }
            }
            this.mobileFormAlias = mobileFormAlias;
            this.QRCodeShow = false;
            this.QRCodeDialog = true;
            this.rowTemplateId = templateId;
            this.rowId = id;
          },
          handleSizeChange: function(size) {
            //每页下拉显示数据
            this.$store.dispatch("form/setBpmTemplatePaginationSize", size);
            this.search();
          },
          handleCurrentChange: function(currentPage) {
            //点击第几页
            this.$store.dispatch(
              "form/setBpmTemplatePaginationPageNum",
              currentPage
            );
            this.search();
          },
          getParam() {
            let params = {};
            if (str == "find") {
              this.$store.dispatch("form/setBpmTemplatePaginationPageNum", 1);
            }

            //判断为合并查询还是分开查询
            if (this.formType) {
              params = this.getQueryFilter();
            } else {
              //判断是否配置了合并查询
              if ($(".search-query").length > 0) {
                params = this.getConditionQuery();
              } else {
                params = this.getQueryFilter();
              }
            }

            if (
              params.pagination &&
              params.pagination &&
              params.pagination.querys
            ) {
              let tempQueryS = [];
              let betweenConditions = {};
              params.pagination.querys.forEach(q => {
                if (
                  q.value &&
                  (q.operation != "BETWEEN" || q.value.constructor == Array)
                ) {
                  tempQueryS.push(q);
                } else if (q.value) {
                  let conditions = q;
                  if (betweenConditions[q.property]) {
                    conditions = betweenConditions[q.property];
                    conditions.value = [conditions.value];
                    conditions.value.push(q.value);
                  }
                  betweenConditions[q.property] = conditions;
                }
              });
              for (const key in betweenConditions) {
                tempQueryS.push(betweenConditions[key]);
              }
              params.pagination.querys = tempQueryS;
            }
            return params;
          },
          search(str) {
            const loading = this.$loading(this.options);
            let params = {};
            if (str == "find") {
              this.$store.dispatch("form/setBpmTemplatePaginationPageNum", 1);
            }
            //判断为合并查询还是分开查询
            if (this.formType) {
              params = this.getQueryFilter();
            } else {
              //判断是否配置了合并查询
              if ($(".search-query").length > 0) {
                params = this.getConditionQuery();
              } else {
                params = this.getQueryFilter();
              }
            }
            if (
              params.pagination &&
              params.pagination &&
              params.pagination.querys
            ) {
              let tempQueryS = [];
              let betweenConditions = {};
              params.pagination.querys.forEach(q => {
                if (
                  q.value &&
                  (q.operation != "BETWEEN" || q.value.constructor == Array)
                ) {
                  tempQueryS.push(q);
                } else if (q.value) {
                  let conditions = q;
                  if (betweenConditions[q.property]) {
                    conditions = betweenConditions[q.property];
                    conditions.value = [conditions.value];
                    conditions.value.push(q.value);
                  }
                  betweenConditions[q.property] = conditions;
                }
              });
              for (const key in betweenConditions) {
                tempQueryS.push(betweenConditions[key]);
              }
              params.pagination.querys = tempQueryS;
            }
            //数据视图控件
            if (this.dataView) {
              if (
                this.dataView.bindSelectd &&
                this.dataView.bindSelectd != ""
              ) {
                params.selectField = this.dataView.bindSelectd;
                params.selectValue = this.dataView.selectValue;
              }
            }
            if ($.isEmptyObject(this.searchForm)) {
              this.$store
                .dispatch("form/getBpmTemplateByPagination", params)
                .then(() => {
                  loading.close();
                });
            } else {
              this.$store
                .dispatch("form/getBpmTemplateByPagination", params)
                .then(() => {
                  loading.close();
                });
            }
          },
          getQueryFilter() {
            let operationMap = this.getSearchItems();
            let querys = []; //查询条件
            let queryFilter = {};
            let pageBean = { pageBean: this.pagination };
            let params = { templateId: this.templateInfo.id };
            params.pagination = pageBean;
            if ($.isEmptyObject(this.searchForm)) {
              return params;
            } else {
              for (let key in this.searchForm) {
                if (
                  typeof this.searchForm[key] != "undefined" &&
                  this.searchForm[key] != ""
                ) {
                  if (this.searchForm[key] instanceof Array) {
                    for (let i = 0; i < this.searchForm[key].length; i++) {
                      querys.push({
                        property: key,
                        value: this.searchForm[key][i],
                        group: "main",
                        operation: operationMap[key],
                        relation: "AND"
                      });
                    }
                  } else {
                    querys.push({
                      property: key,
                      value: this.searchForm[key],
                      group: "main",
                      operation: operationMap[key],
                      relation: "AND"
                    });
                  }
                }
              }
              queryFilter = { pageBean: this.pagination, querys };
              params.pagination = queryFilter;
              return params;
            }
          },
          getSearchItems() {
            let searchItems = $(".search-item");
            let operationMap = {};
            let operationType = {
              like: "LIKE",
              equal: "EQUAL",
              between: "BETWEEN",
              left_like: "LEFT_LIKE",
              right_like: "RIGHT_LIKE"
            };
            if (searchItems) {
              for (let i = 0; i < searchItems.length; i++) {
                let operation = "=";
                if (typeof $(searchItems[i]).attr("eco-query") != "undefined") {
                  operation = $(searchItems[i]).attr("operation");
                  operationMap[$(searchItems[i]).attr("eco-query")] =
                    typeof operationType[operation] != "undefined"
                      ? operationType[operation]
                      : operation;
                } else if (
                  typeof $(searchItems[i])
                    .children()
                    .attr("eco-query") != "undefined"
                ) {
                  operation = $(searchItems[i])
                    .children()
                    .attr("operation");
                  operationMap[
                    $(searchItems[i])
                      .children()
                      .attr("eco-query")
                  ] =
                    typeof operationType[operation] != "undefined"
                      ? operationType[operation]
                      : operation;
                }
              }
            }
            return operationMap;
          },
          getConditionQuery() {
            let searchAll = $(".search-query");
            let values = "";
            let querys = []; //查询条件
            let queryFilter = {};
            let pageBean = { pageBean: this.pagination };
            let params = { templateId: this.templateInfo.id };
            params.pagination = pageBean;
            if (this.queryForm.queryData == "") {
              return params;
            } else {
              if (
                typeof $($(searchAll[0]).children()[0]).attr(
                  "eco-quick-search"
                ) != "undefined"
              ) {
                values = $($(searchAll[0]).children()[0]).attr(
                  "eco-quick-search"
                );
                let arr = values.split(",");
                for (let value of arr) {
                  querys.push({
                    property: value,
                    value: this.queryForm.queryData,
                    group: "main",
                    operation: "LIKE",
                    relation: "OR"
                  });
                }
              }
            }
            queryFilter = { pageBean: this.pagination, querys };
            params.pagination = queryFilter;
            return params;
          },
          //打开高级检索
          advanced() {
            this.formType = !this.formType;
            if (this.formType) {
              this.incons = "el-icon-arrow-up";
              this.queryForm.queryData = "";
            } else {
              this.incons = "el-icon-arrow-down";
              this.searchForm = {};
            }
          },
          //回车查询
          searchEnterFun: function(e) {
            let keyCode = window.event ? e.keyCode : e.which;
            if (keyCode == 13) {
              this.search();
            }
          },
          reset() {
            this.queryForm.queryData = "";
            if (this.templateInfo.conditionField) {
              let conditionField = utils.parseToJson(
                this.templateInfo.conditionField
              );
              for (let i = 0; i < conditionField.length; i++) {
                let fieldName = "F_" + conditionField[i].name;
                this.$set(this.searchForm, fieldName, "");
              }
            }
            this.search();
          },
          handleSelectionChange(vals, row) {
            this.tableData.selectRows = vals;
          },
          deleted() {
            if (
              this.tableData.selectRows == null ||
              this.tableData.selectRows.length == 0
            ) {
              this.$message.warning("请选择文件删除!");
              return false;
            }
            this.$confirm("此操作将删除该文件, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                let s = "";
                for (let i = 0; i < this.tableData.selectRows.length; i++) {
                  s +=
                    s +
                    this.tableData.selectRows[i][this.templateInfo.pkField] +
                    ",";
                }
                s = s.substring(0, s.length - 1);
                let data = { ids: s, boAlias: this.templateInfo.boDefAlias };
                this.$store
                  .dispatch("form/deleteTemplateDataById", data)
                  .then(() => {
                    this.search();
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除"
                });
              });
          },
          del(id) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                let data = { ids: id, boAlias: this.templateInfo.boDefAlias };
                this.$store
                  .dispatch("form/deleteTemplateDataById", data)
                  .then(() => {
                    this.search();
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除"
                });
              });
          },
          operating(templateId, id, action, defId, isStartFlow, openType) {
            if (!templateId) {
              templateId = this.templateInfo.id;
              action = action == "select" ? "get" : "add";
            }
            var url =
              "/statement/template/form/" + this.templateKey + "/" + action;
            if (this.single == "true") {
              url =
                "/statement/template/form/" +
                this.templateKey +
                "/" +
                action +
                "/true";
            }
            if (id) {
              url = url + "?id=" + id + "&";
            } else {
              url += "?";
            }
            let startFlowStr = "startFlow=false";
            if (action == "add" && defId) {
              startFlowStr = "startFlow=true";
            } else if (id && isStartFlow === false && defId) {
              startFlowStr = "startFlow=true";
            }
            let dataUrl = "";
            if (this.dataView) {
              if (this.dataView.bindSelectd) {
                let value = "";
                if (this.dataView.fillValue) {
                  value = this.dataView.fillValue;
                }
                dataUrl =
                  "&fillField=" +
                  this.dataView.bindSelectd +
                  "&fillValue=" +
                  value;
              }
            }
            let path = url + startFlowStr;
            if (dataUrl != "") {
              path = url + startFlowStr + dataUrl;
            }
            if (openType == "new") {
              window.open(
                this.$router.resolve(path + "&isNewPage=true").href,
                "_blank"
              );
            } else {
              this.$router.push(path);
            }
          },
          openUrl(url, type, row, fieldName) {
            if (row && fieldName) {
              url = this.handledUrlParams(url, row, fieldName);
            }
            if (type == "new") {
              window.open(url, "_blank");
            } else {
              window.location.href = url;
            }
          },
          handledUrlParams(url, row, fieldName) {
            if (this.templateInfo.displayField) {
              let displayFields = JSON.parse(this.templateInfo.displayField);
              displayFields.forEach(display => {
                if (display.name == fieldName) {
                  if (display.urlParams && display.urlParams.length > 0) {
                    let urlParams = display.urlParams;
                    let suffix = "";
                    urlParams.forEach(param => {
                      if (suffix) {
                        suffix += "&";
                      }
                      suffix = suffix + param.name + "=" + row[param.field];
                    });
                    if (suffix) {
                      if (url.indexOf("?") != -1) {
                        url = url + "&" + suffix;
                      } else {
                        url = url + "?" + suffix;
                      }
                      return url;
                    }
                  }
                  return url;
                }
              });
            }
            return url;
          },
          viewReport(data, jsonStr, openType) {
            let item = JSON.parse(Base64.decode(jsonStr));
            let conditionField = item.conditionField;
            let querys = [];
            if (conditionField && conditionField.length > 0) {
              conditionField.forEach(obj => {
                if (obj.parameter) {
                  querys.push({
                    property: obj.key,
                    value: data[obj.parameter],
                    group: "main",
                    operation: obj.qt,
                    relation: "AND"
                  });
                }
              });
            }
            var url =
              "/statement/template/preview/" +
              item.alias +
              "/false/" +
              encodeURIComponent(Base64.encode(JSON.stringify(querys)));
            //url 转码防止有斜杠 导致路由跳转不对
            if (openType == "new") {
              window.open(this.$router.resolve(url).href, "_blank");
            } else {
              this.$router.push(url);
            }
          },
          startFlow(id) {
            let data = {
              defKey: this.templateInfo.defId,
              businessKey: id,
              boAlias: this.templateInfo.boDefAlias
            };
            let loadingInstance = Loading.service({ fullscreen: true }); //开始
            this.$store
              .dispatch("storeProcess/startForm", data)
              .then(result => {
                loadingInstance.close(); // 结束
                if (result.state) {
                  this.$message.success(result.message);
                  this.search();
                } else {
                  this.disabled = false;
                  this.$message.error(result.message);
                }
              });
          },
          //自定义列表项相关
          customColumnDialogCancel() {
            // 取消对话框时，可能用户已经勾选或去掉了一些选项，这里需要还原这些勾选操作
            let keys = this.getLocalStorage();
            let currentCustomColumns = null;
            this.customColumns.forEach(col => {
              if (keys === null || keys.indexOf(col.key) > -1) {
                currentCustomColumns
                  ? (currentCustomColumns += "," + col.key)
                  : (currentCustomColumns = col.key);
              }
            });
            this.currentCustomColumns = currentCustomColumns;
            this.judgeCustomColumns = this.currentCustomColumns;
            this.customColumnDialogVisible = false;
            setTimeout(() => {
              this.$refs["multipleTemplateTable"].doLayout();
            }, 100);
          },
          customColumnDialogSure() {
            // 同步选中状态到localStorage中
            if (this.customColumnsHashCode) {
              this.setLocalStorage(
                this.customColumnsHashCode,
                this.currentCustomColumns
              );
            }
            this.customColumnDialogVisible = false;
            this.judgeCustomColumns = this.currentCustomColumns;
            setTimeout(() => {
              this.$refs["multipleTemplateTable"].doLayout();
            }, 100);
          },
          judgeColumnHidden(label) {
            // column是否要显示
            return (
              !this.judgeCustomColumns ||
              this.judgeCustomColumns.indexOf(label) > -1
            );
          },
          getLocalStorage() {
            if (localStorage) {
              let customColumnSetting =
                localStorage.getItem("customColumnSetting") || "{}";
              try {
                customColumnSetting = JSON.parse(customColumnSetting);
              } catch (e) {}
              if (
                !customColumnSetting ||
                typeof customColumnSetting != "object"
              ) {
                customColumnSetting = {};
              }
              return customColumnSetting[this.customColumnsHashCode] || null;
            }
          },
          setLocalStorage(key, value) {
            if (localStorage) {
              let customColumnSetting =
                localStorage.getItem("customColumnSetting") || "{}";
              try {
                customColumnSetting = JSON.parse(customColumnSetting);
              } catch (e) {}
              if (
                !customColumnSetting ||
                typeof customColumnSetting != "object"
              ) {
                customColumnSetting = {};
              }
              if (customColumnSetting) {
                customColumnSetting[key] = value;
                localStorage.setItem(
                  "customColumnSetting",
                  JSON.stringify(customColumnSetting)
                );
              }
            }
          },
          //点击导出按钮
          exports() {
            this.exportType = "main";
            this.displayFields = [];
            if (this.templateInfo.displayField) {
              let displayField = JSON.parse(this.templateInfo.displayField);
              displayField.forEach(item => {
                if (item.type) {
                  this.displayFields.push(item);
                }
              });
            }
            this.subDisplayFieldsList = [...this.subDisplayFields];
            this.dialogExportVisible = true;
          },
          //显示子表对话框
          showSubList(refId) {
            this.refId = refId;
            this.getSubEntsByFormKey(refId);
          },
          //显示修改记录
          openRecordList(refId) {
            this.dialogRecordVisible = true;
            this.recordRefId = refId;
            let param = {
              pageBean: { page: 1, pageSize: 10, showTotal: true },
              sorter: [{ direction: "ASC", property: "modifyTime" }],
              querys: [
                {
                  property: "ref_id_",
                  value: this.recordRefId,
                  group: "main",
                  operation: "EQUAL",
                  relation: "AND"
                }
              ]
            };
            this.recordTableLoading = true;
            let url = "${bpmRunTime}/bpm/boDataModifyRecord/v1/listJson";
            req.post(url, param).then(resp => {
              this.recordTableLoading = false;
              this.recordList = resp.data.rows;
              this.modifyRecord.pagination.pageBean = {
                pageSize: resp.data.pageSize,
                page: resp.data.page,
                total: resp.data.total
              };
            });
          },
          handleRecordCurrentChange(index, modifyRecord) {
            modifyRecord.pagination.pageBean.page = index;
            let param = {
              pageBean: modifyRecord.pagination.pageBean,
              sorter: [{ direction: "ASC", property: "modifyTime" }],
              querys: [
                {
                  property: "ref_id_",
                  value: this.recordRefId,
                  group: "main",
                  operation: "EQUAL",
                  relation: "AND"
                }
              ]
            };
            this.recordTableLoading = true;
            let url = "${bpmRunTime}/bpm/boDataModifyRecord/v1/listJson";
            req.post(url, param).then(resp => {
              this.recordTableLoading = false;
              this.recordList = resp.data.rows;
              this.modifyRecord.pagination.pageBean = {
                pageSize: resp.data.pageSize,
                page: resp.data.page,
                total: resp.data.total
              };
            });
          },
          //取消修改记录对话框
          recordCancel() {
            this.dialogRecordVisible = false;
            this.recordList = [];
            this.recordRefId = "";
            this.modifyRecord = {
              pagination: {
                pageBean: {
                  page: 1,
                  pageSize: 10,
                  total: 0
                }
              }
            };
          },
          //
          openModifyDetail(row) {
            this.currentModify = row;
            this.modifyDetailDialogVisible = true;
          },
          //查看修改记录详情
          showModifyRecord(id, refId) {
            var url =
              "/statement/template/form/" +
              this.templateKey +
              "/get/true" +
              "?id=" +
              refId +
              "&startFlow=false&recordId=" +
              id +
              "&isNewPage=true";
            window.open(this.$router.resolve(url).href, "_blank");
          },
          //确定导出
          submitExport() {
            if (!this.exportData || this.exportData.expField.length < 1) {
              this.$message({
                type: "info",
                message: "请选择要导出的字段！"
              });
              return;
            }

            if (this.exportType === "main") this.exportMain();
            else
              this.exportSubData(
                this.exportData.expField,
                this.refId,
                this.currentTab.entName
              );
          },
          exportMain() {
            let expField = "";
            for (let i = 0; i < this.exportData.expField.length; i++) {
              if (i > 0) {
                expField += ",";
              }
              expField += this.exportData.expField[i].name;
            }
            expField = Base64.encode(expField);

            let data = {
              boAlias: this.templateInfo.alias,
              getType: this.exportData.getType,
              expField: expField,
              filterKey: ""
            };
            data.query = this.getQueryFilter().pagination;
            let loadingInstance = Loading.service({ fullscreen: true }); //开始
            this.$store.dispatch("form/templateExport", data).then(() => {
              loadingInstance.close(); // 结束
              this.dialogExportVisible = false;
            });
            for (let i = 0; i < this.subDisplayFieldsList.length; i++) {
              this.exportSubData(
                this.$refs["subExportTable"][i].selection,
                "",
                this.subDisplayFieldsList[i].name
              );
              this.$set(this.$refs["subExportTable"][i], "selection", []);
            }
          },
          exportSubData(expFields, refId, alias) {
            let expField = [];
            for (let i = 0; i < expFields.length; i++) {
              expField.push({
                key: expFields[i].name,
                value: expFields[i].desc
              });
            }
            let data = {
              alias: alias,
              refId: refId,
              type: this.exportData.getType,
              expField: JSON.stringify(expField),
              filterKey: ""
            };
            data.queryFilter = this.currentTab.pagination;
            let loadingInstance = Loading.service({ fullscreen: true });
            form.subExport(data, resp => {
              loadingInstance.close();
              this.dialogExportVisible = false;
            });
          },
          //取消导出
          exportCancel() {
            this.dialogExportVisible = false;
            this.exportData.expField = [];
          },
          //取消子表对话框
          subCancel() {
            this.dialogSubVisible = false;
            this.tabs = [];
            this.ents = [];
          },
          handleExportSelectionChange(val) {
            this.exportData.expField = [];
            if (val) {
              this.exportData.expField = val;
            }
          },
          //全选
          handleExportSelectAll() {
            this.exportData.expField = this.displayFields;
          },
          //排序
          sort(index, type) {
            if ("up" == type) {
              if (index === 0) {
                this.$message({
                  message: "已经是列表中第一位",
                  type: "warning"
                });
              } else {
                let temp = this.displayFields[index - 1];
                this.$set(
                  this.displayFields,
                  index - 1,
                  this.displayFields[index]
                );
                this.$set(this.displayFields, index, temp);
              }
            } else {
              if (index === this.displayFields.length - 1) {
                this.$message({
                  message: "已经是列表中最后一位",
                  type: "warning"
                });
              } else {
                this.isTransition = true;
                let i = this.displayFields[index + 1];
                this.$set(
                  this.displayFields,
                  index + 1,
                  this.displayFields[index]
                );
                this.$set(this.displayFields, index, i);
              }
            }
          },
          getSubEntsByFormKey(refId) {
            if (!this.ents || this.ents.length < 1) {
              form.getSubEntsByFormKey(this.templateInfo.formKey, resp => {
                this.ents = resp.data;
              });
            } else {
              this.getSubData(this, refId);
            }
          },
          getSubData(_me, refId) {
            let ents = this.ents;
            let tabs = [];
            if (ents && ents.length > 0) {
              for (let i = 0; i < ents.length; i++) {
                let attributeList = ents[i].attributeList;
                let tab = {
                  name: ents[i].tableName,
                  entName: ents[i].name,
                  title: ents[i].comment,
                  attributeList: attributeList,
                  comment: ents[i].comment,
                  pagination: {
                    pageBean: {
                      pageSize: 10,
                      page: 1,
                      total: 0
                    }
                  }
                };
                this.$store
                  .dispatch("form/getSubDataPagination", {
                    pagination: tab.pagination,
                    name: ents[i].name,
                    refId: refId
                  })
                  .then(data => {
                    if (data && data.rows.length > 0) {
                      tab.dataList = data.rows;
                      tab.pagination.pageBean.pageSize = data.pageSize;
                      tab.pagination.pageBean.page = data.page;
                      tab.pagination.pageBean.total = data.total;
                    } else {
                      tab.dataList = [];
                      tab.pagination.pageBean.pageSize = 1;
                      tab.pagination.pageBean.page = 1;
                      tab.pagination.pageBean.total = 0;
                    }
                    this.dialogSubVisible = true;
                    this.tabs.push(tab);
                  });
              }
            }
          },
          nodeClick(node) {
            const loading = this.$loading(this.options);
            this.$store.dispatch("form/setBpmTemplatePaginationPageNum", 1);

            let pageBean = { pageBean: this.pagination };
            pageBean.querys = [];
            if (!node.id || node.id != -1) {
              let treeField = JSON.parse(this.templateInfo.treeField);
              treeField.querys.forEach(item => {
                if (item.key_ && item.value_) {
                  pageBean.querys.push({
                    property: "F_" + item.key_,
                    value: node[item.value_],
                    group: "main",
                    operation: "EQUAL",
                    relation: "AND"
                  });
                }
              });
            }

            let params = {
              templateId: this.templateInfo.id,
              pagination: pageBean
            };

            //数据视图控件
            if (this.dataView) {
              if (
                this.dataView.bindSelectd &&
                this.dataView.bindSelectd != ""
              ) {
                params.selectField = this.dataView.bindSelectd;
                params.selectValue = this.dataView.selectValue;
              }
            }
            this.$store
              .dispatch("form/getBpmTemplateByPagination", params)
              .then(() => {
                loading.close();
              });
          },
          //加载树的信息
          toTreeData(data, id, pid, name, pvalue) {
            // 建立个树形结构,需要定义个最顶层的父节点，pvalue是0
            let parents = data.filter(
              value =>
                value[id] == value[pid] ||
                value[pid] == null ||
                value[pid] == pvalue
            );
            if (!parents) {
              parents = data.filter(
                value =>
                  value[pid] !== "undefined" &&
                  value[pid] != null &&
                  value[id] != value[pid]
              );
            }
            return parents;
          },
          //初始化树
          initTree(treeField) {
            form.getByAlias(treeField.alias, res => {
              this.customDialog = res;
              dialog.getTreeData(
                {
                  requestType: "GET",
                  url:
                    "${form}/form/customDialog/v1/getTreeData?alias=" +
                    treeField.alias +
                    "&mapParam="
                },
                resp => {
                  let displayfield = JSON.parse(this.customDialog.displayfield);
                  this.displayField = displayfield;
                  this.treeList = resp.data;
                  let head = {};
                  head[displayfield.displayName] = "全部";
                  head.id = -1;
                  this.tree.push(head);
                }
              );
            });
          },
          loadTree(node, resolve) {
            if (node) {
              if (node.data.id === -1) {
                let tree = this.toTreeData(
                  this.treeList,
                  this.displayField.id,
                  this.displayField.pid,
                  this.displayField.displayName,
                  this.displayField.pvalue ? this.displayField.pvalue : "0"
                );
                resolve(tree);
              } else {
                resolve(
                  this.treeList.filter(
                    value =>
                      value[this.displayField.pid] ===
                      node.data[this.displayField.id]
                  )
                );
              }
            } else {
              resolve([]);
            }
          },
          handleSubCurrentChange(index, tab) {
            tab.pagination.pageBean.page = index;
            this.subTableLoading = true;
            this.$store
              .dispatch("form/getSubDataPagination", {
                pagination: tab.pagination,
                name: tab.entName,
                refId: this.refId
              })
              .then(resp => {
                tab.pagination.pageBean = {
                  pageSize: resp.pageSize,
                  page: resp.page,
                  total: resp.total
                };
                tab.dataList = resp.rows;
              })
              .finally(() => {
                this.subTableLoading = false;
              });
          },
          querySubTable(tab) {
            tab.pagination.querys = [];
            if (this.querySubValue) {
              tab.attributeList.forEach(item => {
                tab.pagination.querys.push({
                  property: item.fieldName,
                  value: this.querySubValue,
                  group: "other",
                  operation: "LIKE",
                  relation: "OR"
                });
              });
            }
            this.handleSubCurrentChange(1, tab);
          },
          importSub(param) {
            let formData = new FormData();
            formData.append("file", param.file);
            let params = {
              data: formData,
              alias: this.currentTab.entName,
              refId: this.refId
            };
            form.subImport(params, data => {
              if (data.state) {
                this.$message({ type: "success", message: data.message });
                param.onSuccess();
                this.handleSubCurrentChange(1, this.currentTab);
              } else {
                this.$message.error(data.message);
                param.onError();
              }
            });
          },
          exportSub(tab) {
            this.exportType = "sub";
            this.currentTab = tab;
            this.displayFields = [];
            this.subDisplayFieldsList = [];
            tab.attributeList.forEach(item => {
              this.displayFields.push({
                desc: item.comment,
                name: item.fieldName,
                type: item.columnType
              });
            });
            this.dialogExportVisible = true;
          },
          importButton(tab) {
            this.currentTab = tab;
          }
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
>>> th.todo-header-row {
  background-color: #fafafa;
  font-size: 13px;
}

>>> tr.todo-row {
  font-size: 13px;
  color: #000;
}

.el-container {
  background-color: #fff;
}

.el-row {
  margin-bottom: 20px;
}

.el-header {
  border-bottom: 1.5px solid #ededed;
}

.i {
  margin-right: 4px;
}

.todo-subject {
  cursor: pointer;
}

.todo-subject:hover {
  color: #2761ff;
}

>>> .el-dialog__body {
  padding: 15px 10px;
}

>>> .el-checkbox {
  margin-left: 15px;
}

>>> .el-radio {
  margin-left: 15px;
}

>>> .el-button {
  margin-left: 0px;
}

>>>.el-aside {
  border-right: #e2e3e4 1px solid;
}

>>>.el-scrollbar__wrap {
  overflow-x: hidden;
  padding: 23px 10px;
}

>>>.el-scrollbar {
  height: 860px;
  width: 98%;
}

>>>.el-input-group {
  margin-bottom: 10px;
  width: 50%;
}

>>>.template_main_cont {
  position: relative;

  .template_custom_column_cont {
    position: absolute;
    top: 20px;
    right: 20px;

    &>.el-button {
      padding: 6px 3px;
      border-radius: 0;
    }
  }

  .el-row.template_search-cont {

  }

  .el-row.template_toolbar-cont {
    .el-col {
      display: flex;
      justify-content: flex-end;

      .el-button {
        margin: 0 4px;
      }
    }
  }
}
</style>
